<script>
    import ButtonCircular from '../ButtonCircular.svelte'
    import CircularIndicator from '../CircularIndicator.svelte'
    import * as Fx from '../../globals/Fx'
    
    export let LIQUIDADOS = null
    
    let w
    let h

    const _handleClickEvent = (OPCION) => {
        dispatch("click",{opcion : OPCION})
    }
    
</script>
    
    
    <div class="option-container d-flex flex-column align-items-center justify-content-center text-center mx-1 position-relative" style="max-width: 300px;">
        <div style="width: 200px;height:200px;" bind:clientWidth={w} bind:clientHeight={h}>
            {#if LIQUIDADOS }
                <CircularIndicator porc={LIQUIDADOS.porc_liquidados} {w} {h} lineWidth={20} label="Con importe">
                    <div class="buttons">
                        <ButtonCircular
                            {w} {h} n={2} title={"Mostrar Listado"} on:click={() =>_handleClickEvent("AVANCE-LISTADO")}
                        >
                            <ion-icon name="list-outline"></ion-icon>
                        </ButtonCircular>
                    </div>
                </CircularIndicator>
            {:else}
                <CircularIndicator porc={0} {w} {h} lineWidth={20} label="Con importe">
                    <div class="buttons">
                        <ButtonCircular
                            {w} {h} n={2} title={"Mostrar Listado"} on:click={() =>_handleClickEvent("AVANCE-LISTADO")}
                        >
                            <ion-icon name="list-outline"></ion-icon>
                        </ButtonCircular>
                    </div>
                </CircularIndicator>
            {/if}
        </div>
        <span class="title-desc">Importe Liquidado</span>
        <p style="color:#00000055"> El total de importe liquidado es de <strong>{LIQUIDADOS ? Fx.formatter.format(LIQUIDADOS.total_importe_liquidado).cop() : 0}</strong> </p>
    </div>

<style>
    .title-desc {
        margin-top: 10px;
        color: #34495e;
        font-size: 1.5em;
        font-weight: bold;
    }

    .buttons {
        opacity: 0;
        transition: opacity 500ms;
    }

    .option-container:hover .buttons {
        display: flex;
        opacity: 1;
    }        
</style>